import { createContext } from "react"
import type { ToastState } from "./ToastsContext"

// this context holds the toaster root node and callbacks for interacting
// with the toaster
export interface ToasterContextValue {
  toasterRoot?: HTMLElement | null;
  showToast: (id: string, component: ToastState["component"]) => void;
  updateToast: (id: string, status: ToastState["status"]) => void;
  removeToast: (id: string) => void;
}

type ContextType = ToasterContextValue | null

export const ToasterContext = createContext<ContextType>(null)
